import type { HighLevelIssue } from '../types/content';
import { getCategoryImageUrl } from './categoryImages';

const prefetched = new Set<string>();

/** Warms HTTP + service worker cache for all category images after content loads. */
export function prefetchCategoryImages(issues: Pick<HighLevelIssue, 'slug'>[]): void {
  for (const issue of issues) {
    const url = getCategoryImageUrl(issue);
    if (prefetched.has(url)) continue;
    prefetched.add(url);

    void fetch(url, { mode: 'same-origin', credentials: 'same-origin' }).catch(() => {
      prefetched.delete(url);
    });
  }
}

/** Same-origin static files used on every page. */
export function prefetchSiteAssets(): void {
  const urls = [
    '/favicon.svg',
    '/images/democracy-on-the-ballot-favicon.svg',
    '/icons.svg',
  ];

  for (const url of urls) {
    if (prefetched.has(url)) continue;
    prefetched.add(url);
    void fetch(url, { mode: 'same-origin', credentials: 'same-origin' }).catch(() => {
      prefetched.delete(url);
    });
  }
}
